/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S4_TitleInputs */

const en_guide_large_json_files_s4_title = /** @type {(inputs: Guide_Large_Json_Files_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy 3: Split and Process`)
};

const ko_guide_large_json_files_s4_title = /** @type {(inputs: Guide_Large_Json_Files_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략 3: 분할 후 처리`)
};

const ja_guide_large_json_files_s4_title = /** @type {(inputs: Guide_Large_Json_Files_S4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦略3：分割して処理する`)
};

/**
* | output |
* | --- |
* | "Strategy 3: Split and Process" |
*
* @param {Guide_Large_Json_Files_S4_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s4_title = /** @type {((inputs?: Guide_Large_Json_Files_S4_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S4_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s4_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s4_title(inputs)
	return ja_guide_large_json_files_s4_title(inputs)
});